/**
 * configuration for provider
 */

app.provider("_$paginator",function(){
    
    var perPage=20;
    
    this.setPerPage=function(count){
        
        perPage=count;
    };
    
    this.$get=function(){
      
        return {
            
            //get how many results on page
            getPerPage:function(){
             
                return perPage;
                
            }
            
        };
        
    };
    
    
});

